<template>
  <div id="dashboard" style="min-height: 650px;">
    <div id="dashboard" class="content">
      <div class="block block-rounded block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">{{edit=='add'?'新增充电费率':'充电费率详情'}}</h3>
        </div>
        <div class="block-content">
          <form
            action="be_forms_elements.html"
            method="POST"
            enctype="multipart/form-data"
            onsubmit="return false;"
          >
            <h2 class="content-heading pt-0 font-w600">
              基本信息
              <span class="input-required" v-show="edit=='add'">*</span>
            </h2>
            <div class="row push">
              <div class="col-lg-4">选择费率档数后，可在费率详情中自定义收费阶段</div>
              <div class="col-lg-8 col-xl-5">
                <div class="form-group">
                  <!-- <label for="example-text-input">所在区域</label>
                  <div class="col-sm-12 p-0">
                    <select
                      :disabled="edit!='add'"
                      class="form-control width-33"
                      id="cell-province-sel"
                      name="cell-province-sel"
                      @change="provinceSel()"
                      v-model="pro"
                    >
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in provinceList"
                        :key="index"
                        :value="item.DISTRICT_CODE"
                      >{{item.DISTRICT_NAME}}</option>
                    </select>
                    <select
                      :disabled="edit!='add'"
                      class="form-control width-33"
                      id="cell-city-sel"
                      name="cell-city-sel"
                      @change="citySel()"
                      v-model="city"
                    >
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in cityList"
                        :key="index"
                        :value="item.DISTRICT_CODE"
                      >{{item.DISTRICT_NAME}}</option>
                    </select>
                    <select
                      :disabled="edit!='add'"
                      class="form-control width-33"
                      @change="disSel()"
                      v-model="dis"
                    >
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in districtList"
                        :key="index"
                        :value="item.DISTRICT_CODE"
                      >{{item.DISTRICT_NAME}}</option>
                    </select>
                  </div>-->
                  <div class="form-group">
                    <label for="example-text-input">小区名称</label>
                    <el-select
                      filterable
                      placeholder="请输入"
                      style="width: 100%;"
                      v-show="edit=='add'"
                      :disabled="edit!='add'"
                      v-model="cell"
                      @change="getDistrictCode()"
                    >
                      <el-option
                        v-for="(item,index) in cellList"
                        :key="index"
                        :value="item.CELL_ID"
                        :label="item.CELL_NAME"
                      ></el-option>
                    </el-select>
                    <!-- <select
                      v-show="edit=='add'"
                      :disabled="edit!='add'"
                      class="form-control col-sm-12"
                      v-model="cell"
                      @change="getDistrictCode()"
                    >
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in cellList"
                        :key="index"
                        :value="item.CELL_ID"
                      >{{item.CELL_NAME}}</option>
                    </select>-->
                    <input
                      v-show="edit!='add'"
                      disabled
                      class="form-control"
                      placeholder
                      maxlength="30"
                      v-model="cellName"
                    />
                  </div>
                  <div class="form-group">
                    <label for="example-text-input">
                      站点名称
                      <span class="input-required" v-show="edit=='add'">*</span>
                    </label>
                    <el-select
                      filterable
                      placeholder="请选择"
                      style="width: 100%;"
                      v-model="form.siteId"
                      :disabled="edit!='add'"
                      @change="changeSiteId()"
                    >
                      <el-option
                        v-for="item in siteList"
                        :key="item.SITE_ID"
                        :label="item.SITE_NAME"
                        :value="item.SITE_ID"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="form-group inline-block" style="width:48%;margin-right:4%">
                    <label for="example-text-input">
                      费率类型
                      <span class="input-required" v-show="edit=='add'">*</span>
                    </label>
                    <select class="form-control" v-model="form.rateTypeVal" disabled>
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in rateTypeList"
                        :key="index"
                        :value="item.value"
                      >{{item.label}}</option>
                    </select>
                  </div>
                  <div class="form-group inline-block" style="width:48%;">
                    <label for="example-text-input">
                      费率档数
                      <span class="input-required" v-show="edit=='add'">*</span>
                    </label>
                    <select class="form-control" v-model="powerNum" disabled>
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option v-for="(item,index) in 9" :key="index" :value="item">{{item}}</option>
                    </select>
                  </div>
                  <div class="form-group inline-block" style="width:48%;margin-right:4%">
                    <label for="example-text-input">
                      不计费时长(分钟)
                      <span class="input-required" v-show="edit=='add'">*</span>
                    </label>
                    <input
                      class="form-control"
                      placeholder
                      maxlength="2"
                      disabled
                      v-model="form.freeDuration"
                    />
                  </div>

                  <div class="form-group inline-block" style="width:48%;">
                    <label for="example-text-input">
                      仅白名单用户
                      <span class="input-required" v-show="edit=='add'">*</span>
                    </label>
                    <select
                      class="form-control col-sm-12"
                      v-model="form.billType"
                      :disabled="edit!='add'"
                    >
                      <option selected="selected" disabled="disabled" value>请选择</option>
                      <option
                        v-for="(item,index) in showType"
                        :key="index"
                        :value="item.value"
                      >{{item.label}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <h2 class="content-heading pt-0 font-w600">
              费率详情
              <span class="input-required" v-show="edit=='add'">*</span>
            </h2>
            <div class="row push noborder">
              <!-- <div class="col-lg-4">
              </div>-->
              <div class="col-lg-12 col-xl-9 pr-0" style="overflow-x: auto;">
                <!-- <div
                  style="text-align: center;"
                  v-show="form.rateTypeVal!=2 &&form.rateTypeVal!=3"
                >暂无</div>-->
                <!-- 双步长功率 -->
                <table
                  v-show="form.rateTypeVal==2 && powerList.length"
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 60px; min-width:60px">档数</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 100px;width: 100px;"
                      >
                        功率(mA)
                        <span class="input-required" v-show="edit=='add'">*</span>
                      </th>
                      <th class="text-center d-md-table-cell" style="min-width: 135px">
                        起步步长(分钟)
                        <span class="input-required" v-show="edit=='add'">*</span>
                      </th>
                      <th class="text-center d-md-table-cell" style="min-width: 125px">起步费率(元)</th>
                      <th class="text-center d-md-table-cell" style="min-width: 180px">
                        起步时长包扣除(分钟)
                        <span class="input-required" v-show="edit=='add'">*</span>
                      </th>
                      <th class="text-center d-md-table-cell" style="min-width: 140px">
                        后续步长(分钟)
                        <span class="input-required" v-show="edit=='add'">*</span>
                      </th>
                      <th class="text-center d-md-table-cell" style="min-width: 140px">后续费率(元)</th>
                      <th class="text-center d-md-table-cell" style="min-width: 180px">
                        后续时长包扣除(分钟)
                        <span class="input-required" v-show="edit=='add'">*</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="powerList.length">
                    <tr v-for="(item, num) in powerList" :key="num+ '-index'">
                      <td class="text-center">{{num+1}}档</td>
                      <td class="text-center">
                        <input
                          class="form-control col-sm-12"
                          placeholder="毫安"
                          maxlength="5"
                          disabled
                          v-model="item.power"
                          @blur="changeInput0($event,num,'power')"
                          @input="changeInput($event,num,'power')"
                        />
                      </td>

                      <td class="text-center">
                        <input
                          class="form-control col-sm-12"
                          placeholder="分钟"
                          maxlength="6"
                          disabled
                          v-model="item.FirstStep"
                          @blur="changeInput0($event,num,'FirstStep')"
                          @input="changeInput($event,num,'FirstStep')"
                        />
                        <!-- <select
                          class="form-control"
                          v-model="item.FirstStep"
                        >
                          <option selected="selected" disabled="disabled" value>请选择</option>
                          <option
                            v-for="(item,index) in timeList"
                            :key="index"
                            :value="item"
                          >{{item+"分钟"}}</option>
                        </select>-->
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <input
                          class="form-control col-sm-12"
                          placeholder="0元"
                          maxlength="6"
                          disabled
                          v-model="item.FirstStepRate"
                          @input="changeInputThree($event,num,'FirstStepRate')"
                        />
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <input
                          class="form-control col-sm-12"
                          placeholder="分钟"
                          maxlength="3"
                          disabled
                          v-model="item.FirstStepMinute"
                          @blur="changeInput0($event,num,'FirstStepMinute')"
                          @input="changeInput($event,num,'FirstStepMinute')"
                        />
                        <!-- <select
                          class="form-control"
                          v-model="item.FirstStepMinute"
                        >
                          <option selected="selected" disabled="disabled" value>请选择</option>
                          <option
                            v-for="(item,index) in timeList"
                            :key="index"
                            :value="item"
                          >{{item+"分钟"}}</option>
                        </select>-->
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <input
                          class="form-control col-sm-12"
                          placeholder="分钟"
                          maxlength="3"
                          disabled
                          v-model="item.Step"
                          @blur="changeInput0($event,num,'Step')"
                          @input="changeInput($event,num,'Step')"
                        />
                        <!-- <select
                          class="form-control"
                          v-model="item.Step"
                        >
                          <option selected="selected" disabled="disabled" value>请选择</option>
                          <option
                            v-for="(item,index) in timeList"
                            :key="index"
                            :value="item"
                          >{{item+"分钟"}}</option>
                        </select>-->
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <input
                          class="form-control col-sm-12"
                          placeholder="0元"
                          maxlength="6"
                          disabled
                          v-model="item.StepRate"
                          @input="changeInputThree($event,num,'StepRate')"
                        />
                      </td>
                      <td class="text-center d-xl-table-cell" style="min-width:80px;">
                        <input
                          class="form-control col-sm-12"
                          placeholder="分钟"
                          maxlength="3"
                          disabled
                          v-model="item.StepMinute"
                          @blur="changeInput0($event,num,'StepMinute')"
                          @input="changeInput($event,num,'StepMinute')"
                        />
                        <!-- <select
                          class="form-control"
                          v-model="item.StepMinute"
                        >
                          <option selected="selected" disabled="disabled" value>请选择</option>
                          <option
                            v-for="(item,index) in timeList"
                            :key="index"
                            :value="item"
                          >{{item+"分钟"}}</option>
                        </select>-->
                      </td>
                    </tr>
                  </tbody>
                  <!-- <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="8">查无数据</td>
                    </tr>
                  </tbody>-->
                </table>
                <!-- 分段功率 -->
                <table
                  v-show="form.rateTypeVal==3 && powerList.length"
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 60px; min-width:60px">档数</th>
                      <th class="text-center d-md-table-cell" style="min-width: 90px;width: 90px;">
                        功率(mA)
                        <span class="input-required" v-show="edit=='add'">*</span>
                      </th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 125px;width: 125px;"
                      >
                        步长(分钟)
                        <span class="input-required" v-show="edit=='add'">*</span>
                      </th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 110px;width: 110px;"
                      >费率(元)</th>
                      <th
                        class="text-center d-md-table-cell"
                        style="min-width: 100px;width: 100px;"
                      ></th>
                    </tr>
                  </thead>
                  <tbody
                    v-show="powerList.length"
                    v-for="(item, dex) in powerList"
                    :key="dex+ '-d'"
                  >
                    <tr v-for="(d, i) in item.DataList" :key="i">
                      <td class="text-center pb-1 pt-1">{{ dex + 1 }}档</td>
                      <td class="text-center pb-1 pt-1">
                        <input
                          class="form-control col-sm-12"
                          placeholder="毫安"
                          maxlength="5"
                          disabled
                          v-model="item.power"
                          @blur="changeInput0($event,dex,'power')"
                          @input="changeInput($event,dex,'power')"
                        />
                      </td>
                      <td class="text-center pb-1 pt-1">
                        <input
                          class="form-control col-sm-12"
                          placeholder="分钟"
                          maxlength="6"
                          disabled
                          v-model="d.Step"
                          @blur="changeInputSubsection0($event,dex,i,'Step')"
                          @input="changeInputSubsection($event,dex,i,'Step')"
                        />
                        <!-- <select
                          class="form-control"
                          v-model="d.Step"
                        >
                          <option selected="selected" disabled="disabled" value>请选择</option>
                          <option
                            v-for="(item,index) in timeList"
                            :key="index"
                            :value="item"
                          >{{item+"分钟"}}</option>
                        </select>-->
                      </td>
                      <td class="text-center d-xl-table-cell pb-1 pt-1" style="min-width:80px;">
                        <input
                          class="form-control col-sm-12"
                          placeholder="0元"
                          maxlength="6"
                          disabled
                          v-model="d.Rate"
                          @input="changeInputSubsectionThree($event,dex,i,'Rate')"
                        />
                      </td>
                      <td class="text-right d-xl-table-cell pb-0 pt-0" style="min-width:80px;">
                        <!-- <div
                          class="btn-group mb-2 mt-2"
                          role="group"
                          aria-label="Icons Outline File group"
                          v-show="form.rateTypeVal==3"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-primary"
                            style="font-weight: 400;"
                            @click="addPower(dex)"
                          >增加</button>
                          <button
                            type="button"
                            class="btn btn-outline-primary"
                            style="font-weight: 400;"
                            @click="delPower(dex)"
                          >删除</button>
                        </div>-->
                      </td>
                    </tr>
                  </tbody>
                  <!-- <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="5">查无数据</td>
                    </tr>
                  </tbody>-->
                </table>
              </div>
            </div>
            <!-- <div class="row push">
              <div class="col-lg-4"></div>
              <div class="col-lg-8 col-xl-5">
                <div class="form-group inline-block" style="width:100%;">
                  <button
                    style="width:100%;"
                    type="button"
                    class="btn btn-sm btn-primary"
                    @click="submit()"
                  >保存</button>
                </div>
              </div>
            </div>-->
          </form>
        </div>
        <!-- END Page Content -->
      </div>
    </div>
  </div>
</template>

<script>
import Util from "../../../Util.js";

export default {
  name: "index",
  data() {
    return {
      provinceList: [],
      cityList: [],
      districtList: [],
      cellList: [],
      pro: "",
      city: "",
      dis: "",
      form: {
        cellId: "",
        remark: "",
        rateTypeVal: "",
        freeDuration: 5,
        deviceType: "",
        billType: 0,
        siteId: ""
      },
      powerList: [],
      siteList: [],
      powerNum: "",
      num: 0,
      cellName: "",
      cell: "",
      code: "",
      rateTypeList: [
        {
          value: 2,
          label: "双步长"
        },
        {
          value: 3,
          label: "分段"
        }
      ],
      showType: [
        {
          value: 1,
          label: "是"
        },
        {
          value: 0,
          label: "否"
        }
      ],
      timeList: [30, 60, 90, 120, 180, 240, 300],
      edit: ""
    };
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    params() {
      return this.$store.state.params;
    }
  },
  watch: {
    // 功率档数
    powerNum: {
      handler: function(val, oldVal) {
        if (oldVal === "" && this.edit != "add") return;
        let num = val;
        if (this.powerList.length) {
          num = Math.abs(this.powerList.length - val);
        }
        if (num > 0) {
          if (val > oldVal) {
            if (this.form.rateTypeVal == 2) {
              for (let i = 0; i < num; i++) {
                this.powerList.push({
                  power:
                    this._powerList && this._powerList[this.powerList.length]
                      ? this._powerList[this.powerList.length]
                      : "",
                  // power: 0,
                  Step: "",
                  FirstStepRate: "",
                  FirstStep: "",
                  StepRate: "",
                  PowerType: this.powerList.length + 1,
                  FirstStepMinute: "",
                  StepMinute: ""
                });
              }
            } else if (this.form.rateTypeVal == 3) {
              for (let i = 0; i < num; i++) {
                this.powerList.push({
                  power:
                    this._powerList && this._powerList[this.powerList.length]
                      ? this._powerList[this.powerList.length]
                      : "",
                  // power: 0,
                  PowerType: this.powerList.length + 1,
                  DataList: [
                    {
                      Rate: "",
                      Step: ""
                    }
                  ]
                });
              }
            }
          } else {
            for (let i = 0; i < num; i++) {
              this.powerList.pop();
            }
          }
        }
      },
      immediate: true,
      deep: true
    },
    // 功率类型
    "form.rateTypeVal": {
      handler: function(val, oldVal) {
        if (oldVal === "" && this.edit != "add") return;
        if (typeof oldVal == "null") {
          this.powerNum = "";
        }
        this.powerList = [];
        if (this.form.rateTypeVal == 2 && this.powerNum) {
          for (let i = 0; i < this.powerNum; i++) {
            this.powerList.push({
              power:
                this._powerList && this._powerList[this.powerList.length]
                  ? this._powerList[this.powerList.length]
                  : "",
              // power: 0,
              Step: "",
              FirstStepRate: "",
              FirstStep: "",
              StepRate: "",
              PowerType: this.powerList.length + 1,
              FirstStepMinute: "",
              StepMinute: ""
            });
          }
        } else if (this.form.rateTypeVal == 3 && this.powerNum) {
          for (let i = 0; i < this.powerNum; i++) {
            this.powerList.push({
              power:
                this._powerList && this._powerList[this.powerList.length]
                  ? this._powerList[this.powerList.length]
                  : "",
              // power: 0,
              PowerType: this.powerList.length + 1,
              DataList: [
                {
                  Rate: "",
                  Step: ""
                }
              ]
            });
          }
        }
      }
    },
    "form.freeDuration"(val, oldVal) {
      this.form.freeDuration = Util.testNumberFn(val, "inputChangeNoDecimal");
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    this.edit = this.$route.params.id;
    this.getProvince();
    if (this.edit != "add") {
      this.getDetail(this.edit);
    } else {
      this.powerNum = 1;
      this.form.rateTypeVal = "2";
      this.powerList = [
        {
          power: "",
          Step: "",
          FirstStepRate: "",
          FirstStep: "",
          StepRate: "",
          PowerType: 1,
          FirstStepMinute: "",
          StepMinute: ""
        }
      ];
    }
    this.getCellInfo();
  },
  methods: {
    getCellInfo() {
      this.$http.get(`${Util.searchURL}/FlatComplex/SearchBy/?key=`).then(
        res => {
          if (res.data.code === 200) {
            if (res.data.data) {
              this.cellList = res.data.data;
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    changeInput0(e, i, val) {
      if (Util.testNumber(e.target.value) || e.target.value == 0) {
        this.powerList[i][val] = "";
      } else {
        this.powerList[i][val] = Util.inputChangeNoDecimal(e.target.value);
      }
    },
    changeInput(e, i, val) {
      this.powerList[i][val] = Util.testNumberFn(
        e.target.value,
        "inputChangeNoDecimal"
      );
    },
    changeInputTwo0(e, i, val) {
      if (Util.testNumber(e.target.value) || e.target.value == 0) {
        this.powerList[i][val] = "";
      } else {
        this.powerList[i][val] = Util.inputChangeTwoDecimal(e.target.value);
      }
    },
    changeInputThree(e, i, val) {
      this.powerList[i][val] = Util.testNumberFn(
        e.target.value,
        "inputChangeThreeDecimal"
      );
    },
    changeInputSubsection0(e, i, x, val) {
      if (Util.testNumber(e.target.value) || e.target.value == 0) {
        this.powerList[i].DataList[x][val] = "";
      } else {
        this.powerList[i].DataList[x][val] = Util.inputChangeNoDecimal(
          e.target.value
        );
      }
    },
    changeInputSubsection(e, i, x, val) {
      this.powerList[i].DataList[x][val] = Util.testNumberFn(
        e.target.value,
        "inputChangeNoDecimal"
      );
    },
    changeInputSubsectionTwo0(e, i, x, val) {
      if (Util.testNumber(e.target.value) || e.target.value == 0) {
        this.powerList[i].DataList[x][val] = "";
      } else {
        this.powerList[i].DataList[x][val] = Util.inputChangeTwoDecimal(
          e.target.value
        );
      }
    },
    changeInputSubsectionThree(e, i, x, val) {
      this.powerList[i].DataList[x][val] = Util.testNumberFn(
        e.target.value,
        "inputChangeThreeDecimal"
      );
    },

    cellSel(val) {
      this.$http.get(`${Util.searchURL}/Power/GetByCell/${val}`).then(
        res => {
          if (res.data.code === 200) {
            this._powerList = res.data.data;
            // this.powerNum = this._powerList.length;
            if (this.edit != "add") return;
            this.powerList = [];
            if (this.form.rateTypeVal == 2 && this.powerNum) {
              for (let i = 0; i < this.powerNum; i++) {
                this.powerList.push({
                  power:
                    this._powerList && this._powerList[this.powerList.length]
                      ? this._powerList[this.powerList.length]
                      : "",
                  // power: 0,
                  Step: "",
                  FirstStepRate: "",
                  FirstStep: "",
                  StepRate: "",
                  PowerType: this.powerList.length + 1,
                  FirstStepMinute: "",
                  StepMinute: ""
                });
              }
            } else if (this.form.rateTypeVal == 3 && this.powerNum) {
              for (let i = 0; i < this.powerNum; i++) {
                this.powerList.push({
                  power:
                    this._powerList && this._powerList[this.powerList.length]
                      ? this._powerList[this.powerList.length]
                      : "",
                  // power: 0,
                  PowerType: this.powerList.length + 1,
                  DataList: [
                    {
                      Rate: "",
                      Step: ""
                    }
                  ]
                });
              }
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    getDistrictCode() {
      if (!this.dis && !this.city && !this.cell) {
        this.code = this.pro;
      }
      if (!this.dis && this.city && !this.cell) {
        this.code = this.city;
      }
      if (this.dis && !this.cell) {
        this.code = this.dis;
      }
      if (this.cell) {
        this.code = this.cell;
      }
      this.getSite(this.code);
    },
    getSite(val, id) {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListBySiteByCell/${val}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.siteList = res.data.data;
              this.form.siteId = "";
              if (id) {
                this.form.siteId = id;
              }
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    // 改变站点时
    changeSiteId() {
      for (let i in this.siteList) {
        if (this.form.siteId == this.siteList[i].SITE_ID) {
          this.form.cellId = this.siteList[i].CELL_ID;
          this.cellSel(this.siteList[i].CELL_ID);
        }
      }
    },
    // 编辑时获取信息
    getDetail(id) {
      this.$http.get(`${Util.searchURL}/Billing/GetRate/${id}`).then(
        res => {
          if (res.data.code === 200) {
            let d = res.data.data.rate[0];
            this.getSite(d.CELL_ID, d.SITE_ID);
            this.form = {
              id: d.ID,
              cellId: d.CELL_ID,
              remark: d.REMARK,
              freeDuration: d.FREE_DURATION,
              rateTypeVal:
                d.RATE_TYPE == "BillingNormal"
                  ? 2
                  : d.RATE_TYPE == "BillingSection"
                  ? 3
                  : 1,
              deviceType: d.DeviceType.toString(),
              billType: d.TYPE,
              siteId: d.SITE_ID
            };
            this.cellName = d.CELL_NAME;
            Util.displayAreaCell(
              d.CELL_ID,
              this,
              true,
              this.edit == "" ? true : false
            );
            this.cellSel(d.CELL_ID);
            this._powerList = res.data.data.power.data;
            this.powerList = res.data.data.power.data;
            // 分段
            if (d.RATE_TYPE == "BillingSection") {
              this._powerList = res.data.data.rateData;
              this.powerList = res.data.data.rateData;
            }
            this.powerNum = this.powerList.length;
          }
        },
        err => {
          console.log(err);
        }
      );
    },

    submit() {
      let url = "";
      if (this.edit == "add") {
        url = `${Util.operateURL}/rateManagement/addRate`;
      } else {
        url = `${Util.operateURL}/rateManagement/updateRate`;
      }
      this.form.rateData = this.powerList;
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            Util.message("succ", res.data.desc);
            this.$router.go(-1);
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },

    getProvince() {
      this.$http.get(`${Util.searchURL}/Province/ListAll`).then(
        res => {
          if (res.data.code === 200) {
            this.provinceList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    provinceSel() {
      let pid = $(`#cell-province-sel`).val();
      this.$http.get(`${Util.searchURL}/City/ListByProvince/${pid}`).then(
        res => {
          if (res.data.code === 200) {
            this.cityList = res.data.data;
            this.city = "";
            this.dis = "";
            this.cell = "";
            this.getDistrictCode();
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    citySel() {
      let pid = $(`#cell-city-sel`).val();
      this.$http.get(`${Util.searchURL}/District/ListByCity/${pid}`).then(
        res => {
          if (res.data.code === 200) {
            this.districtList = res.data.data;
            this.dis = "";
            this.cell = "";
            this.getDistrictCode();
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
              this.cell = "";
              this.getDistrictCode();
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    addPower(i) {
      if (this.form.rateTypeVal == 3) {
        if (this.powerList[i].DataList.length > 9) {
          Util.message("war", "达到分段费率个数添加上线");
          return;
        }
        this.powerList[i].DataList.push({
          Rate: "",
          Step: ""
        });
      } else if (this.form.rateTypeVal == 2) {
        this.powerList.push({
          Step: "",
          FirstStepRate: "",
          FirstStep: "",
          StepRate: "",
          PowerType: this.powerList.length
        });
      }
    },
    delPower(i) {
      if (this.form.rateTypeVal == 3) {
        if (this.powerList[i].DataList.length == 1) {
          Util.message("war", "不能删除");
          return;
        }
        this.powerList[i].DataList.pop();
      } else if (this.form.rateTypeVal == 2) {
        if (this.powerList.length == 1) {
          Util.message("war", "不能删除");
          return;
        } else {
          this.powerList.pop();
        }
      }
    }
  }
};
</script>
<style lang="less" scope>
.noborder {
  .table-bordered th,
  .table-bordered,
  .table-bordered td,
  .table th,
  .table td {
    border: none !important;
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #ffffff !important;
  }
  .table tbody + tbody {
    border-top: none;
  }
}
</style>

